import objectionTrackerActions from "./actions";

const initialState = {
  objQuestionDetails: [],
  objQuestionDetailsCount: [],
  refundStatus : [],
};

const objectionTrackerReducer = (state = initialState, action) => {
  switch (action.type) {
    case objectionTrackerActions.SET_OBJECTION_QUESTION_DETAILS:
      return {
        ...state,
        objQuestionDetails: action.payload
      };
 
    case objectionTrackerActions.SET_OBJECTION_QUESTION_DETAILS_COUNT:
      return {
        ...state,
        objQuestionDetailsCount: action.payload
      };

      case objectionTrackerActions.SET_REFUND_STATUS:
        return {
          ...state,
          refundStatus: action.payload
        };
 
    

    default:
      return state;
  }
};

export default objectionTrackerReducer;